import { useQuery } from "react-query";
import { useDealer } from "./useDealer";
import {
  DealerMainIProps,
  ParamsIProps,
  PassportIProps,
} from "../model/schema";

interface useDataMainResult<T> {
  data: T | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch?: () => void;
}

interface OptionsIProps {
  fetchDataDealerMain?: boolean;
  fetchMainDataById?: boolean;
}

export const useDataMain = (
  props: ParamsIProps,
  options: OptionsIProps = {}
) => {
  const { getDataMain, getPassportMainData, queryKeys } = useDealer();
  const { fetchDataDealerMain = true, fetchMainDataById = true } = options;

  const params = new URLSearchParams();
  Object.keys(props).map((item) => params.append(item, props[item]));
  const paramsString = params.toString();

  const getDataDealerMainQuery = useQuery(
    queryKeys.getDataMainById(props.id),
    () => getDataMain(paramsString).then((res) => res.data),
    {
      enabled: !!props.id && fetchDataDealerMain,
      refetchOnWindowFocus: false,
    }
  );

  const getMainDataByIdQuery = useQuery(
    queryKeys.getPassportMainDataById(props.id),
    () => getPassportMainData(props.id).then((res) => res.data),
    {
      enabled: !!props.id && fetchMainDataById,
      refetchOnWindowFocus: false,
    }
  );

  const getDataDealerMain: useDataMainResult<DealerMainIProps> = {
    data: getDataDealerMainQuery.data,
    isLoading: getDataDealerMainQuery.isLoading,
    isError: getDataDealerMainQuery.isError,
    refetch: getDataDealerMainQuery.refetch,
  };

  const getMainDataById: useDataMainResult<PassportIProps> = {
    data: getMainDataByIdQuery.data,
    isLoading: getMainDataByIdQuery.isLoading,
    isError: getMainDataByIdQuery.isError,
    refetch: getMainDataByIdQuery.refetch,
  };

  return {
    getDataDealerMain,
    getMainDataById,
  };
};
